import { render } from "./TaxAndRegistration.vue?vue&type=template&id=384c8e92&scoped=true"
import script from "./TaxAndRegistration.vue?vue&type=script&lang=js"
export * from "./TaxAndRegistration.vue?vue&type=script&lang=js"

import "./TaxAndRegistration.vue?vue&type=style&index=0&id=384c8e92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384c8e92"]])

export default __exports__